import React from 'react';
import { FormControl, FormLabel, Input, Switch } from '@chakra-ui/react';

const CustomTemplate = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>HTML</FormLabel>
        <Input
          name="actionProps.customTemplate.html"
          value={formik.values.actionProps.customTemplate.html}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>CSS</FormLabel>
        <Input
          name="actionProps.customTemplate.css"
          value={formik.values.actionProps.customTemplate.css}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Height</FormLabel>
        <Input
          name="actionProps.customTemplate.height"
          value={formik.values.actionProps.customTemplate.height}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Width</FormLabel>
        <Input
          name="actionProps.customTemplate.width"
          value={formik.values.actionProps.customTemplate.width}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Endpoint URL</FormLabel>
        <Input
          name="actionProps.customTemplate.endpoint"
          value={formik.values.actionProps.customTemplate.endpoint}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Redirect Status</FormLabel>
        <Switch
          name="actionProps.customTemplate.redirect.status"
          isChecked={formik.values.actionProps.customTemplate.redirect.status}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Redirect URL</FormLabel>
        <Input
          name="actionProps.customTemplate.redirect.url"
          value={formik.values.actionProps.customTemplate.redirect.url}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Background Color</FormLabel>
        <Input
          name="actionProps.customTemplate.background.color"
          value={formik.values.actionProps.customTemplate.background.color}
          onChange={formik.handleChange}
        />
      </FormControl>
    </>
  );
};

export default CustomTemplate;